const { round, sin, cos, atan2 } = Math;

export const clamp = (value: number, min: number, max: number) =>
  value < min ? min : value > max ? max : value;

export const snap = (value: number, snap: number) => round(value / snap) * snap;

export const angleDifference = (angleA: number, angleB: number) =>
  atan2(sin(angleA - angleB), cos(angleA - angleB));
